import { Component, OnInit,ViewChild,ViewContainerRef, Output, EventEmitter } from '@angular/core';
import { Constants } from '../Services/Constants';
import { HTTPService } from '../Services/http.service';
import { Observable } from 'rxjs/Observable';
import { filter } from '../App/search.pipe';
import { MySharedService } from '../App/shared.service';
import { Router} from '@angular/router';
import { DomSanitizer, SafeResourceUrl, SafeUrl} from '@angular/platform-browser';

declare function ExportToExcel(item: any[], workSheetName: string, keys: any, Columns?: any): void;

@Component({
    templateUrl: './AppViews/Invoice/InvoicePDFPrint.html'
})

export class InvoicePDFPrintComponent implements OnInit {
    userDetail: any;
    public constants: Constants;
 
    public InvoicePDFPrintId:any = null;
    public StageId:any = null;
    
    public showLoader = false;
    public safeDocUrl:SafeUrl;
    public DocURL:any;


    constructor(private _httpService: HTTPService, private _sharedService: MySharedService,private _route: Router,private sanitizer: DomSanitizer) {
         this.constants = new Constants();
        this.userDetail = JSON.parse(localStorage.getItem("userDetail"));
        this.InvoicePDFPrintId = JSON.parse(localStorage.getItem("BillId"));
        
    }

    ngOnInit() {
        
        this.printInvoicePDf();
      if(this.DocURL == null || this.DocURL == ""){
      this.DocURL = "../App/images/nocontent.png";
       var safeUrl =  this.sanitizer.bypassSecurityTrustResourceUrl(JSON.parse(JSON.stringify(this.DocURL)));

       this.safeDocUrl =  safeUrl;
   }
    }

   

   
    public printInvoicePDf(){
 this.showLoader = true;

 this._httpService.ajaxPost('TimesheetInvoice/GetprintInvoicePDf', { "BillId":this.InvoicePDFPrintId}).subscribe(
            data => {
         

     this.DocURL=data["DocName"][1];
       var safeUrl =  this.sanitizer.bypassSecurityTrustResourceUrl(JSON.parse(JSON.stringify(this.DocURL)));

       this.safeDocUrl =  safeUrl;
                this.showLoader = false;
            },
            err => {
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constants.globalError);
            },
            () => {
                this.showLoader = false;
            }
        );
    }  



        
    }



/** WEBPACK FOOTER **
 ** ./TypeScripts/Invoice/InvoicePDFPrint.component.ts
 **/